var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcertisIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.903 12.8847L13.3442 10.2004V13.0059L13.903 12.8847Z",
    fill: "#874451"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.70264 2.6778V3.21986L6.19806 2.6778H3.70264Z",
    fill: "#874451"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.39238 14.2986H4.48639V14.1132L4.3084 14.1514L3.70264 11.2381V15.1004L7.39238 14.2986Z",
    fill: "#874451"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9473 3.47909L11.7806 2.6778H10.9802L11.147 3.47909L12.9749 12.2679L4.48657 14.1128V14.2981H7.39254L13.3446 13.0056V10.2002L11.9473 3.47909Z",
    fill: "#874451"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.10654 3.56786L3.70251 3.22081V2.67874H6.19796L10.7729 1.68484L10.98 2.67874H11.7803L11.3757 0.732727L1.17505 2.94826L3.70251 15.101V11.2386L2.10654 3.56786Z",
    fill: "#874451"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4989 2.6778H6.19806L3.70264 3.21986V11.2377L4.3084 14.1509L4.48639 14.1128V3.47909H10.6662L10.4989 2.6778Z",
    fill: "#874451"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2687 2.6778L12.4355 3.47909H13.3444V10.2002L13.9033 12.8845L13.3444 13.0056V14.2981H7.39238L3.70264 15.1V15.1031H14.1323V2.6778H12.2687Z",
    fill: "#874451"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcertisIcon);
export default __webpack_public_path__ + "static/media/IcertisIcon.6e95236625e6e59d1457241ca7a8a4ab.svg";
export { ForwardRef as ReactComponent };